import { CustomerLayout } from "@/components/CustomerLayout/CustomerLayout";
import { LoginButton } from "@/components/LoginButton/LoginButton";
import { PageWithScene } from "@/components/PageWithScene/PageWithScene";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/ny-bruker/")({
  validateSearch: z.object({
    status: z.enum(["ok", "feil"]).optional(),
    error: z.string().optional(), // Added by the API login handler
  }),
  head: () => ({
    meta: [{ title: "Ny bruker | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { status, error } = Route.useSearch();

  return (
    <CustomerLayout>
      <PageWithScene heading="Ny bruker" scene="Alice-Bob">
        <LoginButton
          label="Registrer"
          type="new-user"
          successUrl="/ny-bruker?status=ok"
          errorUrl="/ny-bruker?status=feil"
          disabled={status === "ok"}
        />

        {status === "ok" && (
          <p>Registrering av ny bruker er registrert. Vi vil opprette en bruker i løpet av kort tid.</p>
        )}
        {status === "feil" && <p>{error ?? "Noe gikk galt"}</p>}
      </PageWithScene>
    </CustomerLayout>
  );
}
